import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: '#ffffff',
    backgroundColor: '#23252B',
    borderColor: '#363941',
    borderWidth: '1px',
    borderStyle: 'solid',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: '#848D97',
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: '#ffffff',
  backgroundColor: '#23252B',
  border: '1px solid #363941',
  '&:hover': {
    borderColor: 'white',
    backgroundColor: '#23252B',
  },
}));

const RotateIcon = styled(KeyboardArrowDownIcon)(({ open }) => ({
  color: '#848D97',
  transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.3s ease',
}));

export default function FileMenu({ uploadDataAsJson, downloadDataAsJson, selectedDoppleDetails }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <StyledButton
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<RotateIcon open={open} />}
      >
        File
      </StyledButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => {
          const fileInput = document.getElementById("fileInput");
          if (fileInput) fileInput.click();
          handleClose();
        }} disableRipple>
          <UploadOutlined />
          <span className='pl-2'> Upload Dopple</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (downloadDataAsJson) downloadDataAsJson();
            handleClose();
          }}
          disableRipple
          disabled={!selectedDoppleDetails}
        >
          <DownloadOutlined />
          <span className='pl-2'> Download Dopple</span>
        </MenuItem>
      </StyledMenu>
      <input
        type="file"
        id="fileInput"
        style={{ display: "none" }}
        accept=".json"
        onChange={uploadDataAsJson}
      />
    </div>
  );
}
